"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _FootballMatch = _interopRequireDefault(require("../footballMatch/FootballMatch"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _actions = require("./actions");

var _shared = require("./middle/shared");

var _BetbarUpperArrow = _interopRequireDefault(require("./BetbarUpperArrow"));

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledTopRow = _styledComponents.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: left;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 4rem;\n  width: 100%;\n  padding: 0 0.5rem;\n"])));

var StyledEnd = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 0 1 100px;\n  max-width: 100px;\n  width: 100px;\n  min-width: 100px;\n  display: flex;\n  flex-direction: column;\n  align-items: ", ";\n  justify-content: center;\n"])), function (p) {
  return p.isRight ? "flex-end" : null;
});

var pulse = function pulse(p) {
  var _p$theme$colorDark, _p$theme$colorDark2, _p$theme$colorDark3;

  return (0, _styledComponents.keyframes)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% { box-shadow: 0 0 0 0 ", "; }\n  33% { box-shadow: 0 0 0 3px ", "; }\n  100% { box-shadow: 0 0 0 3px ", "; }\n"])), (0, _polished.rgba)((_p$theme$colorDark = p.theme.colorDark) !== null && _p$theme$colorDark !== void 0 ? _p$theme$colorDark : "white", 0.5), (0, _polished.rgba)((_p$theme$colorDark2 = p.theme.colorDark) !== null && _p$theme$colorDark2 !== void 0 ? _p$theme$colorDark2 : "white", 0), (0, _polished.rgba)((_p$theme$colorDark3 = p.theme.colorDark) !== null && _p$theme$colorDark3 !== void 0 ? _p$theme$colorDark3 : "white", 0));
};

var StyledDropdownButton = _styledComponents.default.button(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 0 0.25rem 0 0.5rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  height: 32px;\n  width: 100%\n  margin-right: auto;\n  text-align: center;\n  background: #ecf0f5;\n  background-clip: border-box;\n  display: flex;\n  align-items: center;\n\n  animation: ", " 3s infinite linear;\n\n  & span {\n    font-size: 20px;\n    transform: rotate(", ")\n      translateY(-1px);\n    transition: transform 0.35s;\n  }\n"])), function (p) {
  return p.needsPulse ? pulse : null;
}, function (p) {
  return !p.isBetsOpen ? "0" : "-180deg";
});

var StyledSvg = _styledComponents.default.svg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 14px;\n  height: 14px;\n  margin-right: 0.325rem;\n"])));

var StyledPath = _styledComponents.default.path(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (p) {
  return p.theme.colorText;
});

var StyledBrandingImage = _styledComponents.default.img(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 1rem;\n  transform: translateY(-50%);\n  height: 33px;\n"])));

var Low6Svg = function Low6Svg() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledSvg, {
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPath, {
      d: "M0.42021 0.406738H10.1869L6.61567 5.76142C5.66441 6.91389 5.10174 8.33752 5.00804 9.82893L0.255859 1.46928C0.255859 1.46928 -0.417334 0.602309 0.42021 0.406738ZM13.4879 0.406738L11.0169 4.12724C11.0169 4.12724 14.8264 4.01564 16.4383 8.22812C16.6007 8.74666 16.6812 9.28736 16.677 9.83072L21.4388 1.4804C21.4388 1.4804 22.318 0.529463 21.0358 0.408533L13.4879 0.406738Z",
      fill: "black"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPath, {
      d: "M10.9062 13.2486C12.6482 13.2486 14.0604 11.8113 14.0604 10.0384C14.0604 8.26539 12.6482 6.82812 10.9062 6.82812C9.16416 6.82812 7.75195 8.26539 7.75195 10.0384C7.75195 11.8113 9.16416 13.2486 10.9062 13.2486Z",
      fill: "black"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPath, {
      d: "M8.13965 15.3647C8.97699 15.7861 9.90134 16.0055 10.8387 16.0055C11.7761 16.0055 12.7004 15.7861 13.5378 15.3647L11.23 19.5022C11.1897 19.5656 11.134 19.6177 11.0681 19.6539C11.0023 19.69 10.9284 19.7089 10.8532 19.7089C10.7781 19.7089 10.7042 19.69 10.6384 19.6539C10.5725 19.6177 10.5168 19.5656 10.4764 19.5022L8.13965 15.3647Z",
      fill: "black"
    })]
  });
};

var Wrapper = function Wrapper(_ref) {
  var _footballMatch, _footballMatch2, _footballMatch2$kicko, _footballMatch3;

  var app = _ref.app,
      setBetbarParent = _ref.setBetbarParent,
      showOnlyFixture = _ref.showOnlyFixture,
      brandingImageUrl = _ref.brandingImageUrl,
      isDpg = _ref.isDpg,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages,
      disableDropdown = _ref.disableDropdown,
      showNavigationArrows = _ref.showNavigationArrows;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useSelector = (0, _reactRedux.useSelector)(function (s) {
    return s.betbar;
  }),
      activePickem = _useSelector.activePickem,
      activePickemList = _useSelector.activePickemList,
      activeBet = _useSelector.activeBet,
      hadBet = _useSelector.hadBet,
      isBetsOpen = _useSelector.isBetsOpen,
      isShowingMyBet = _useSelector.isShowingMyBet,
      isActivePickemApproved = _useSelector.isActivePickemApproved,
      isActivePickemCompleted = _useSelector.isActivePickemCompleted,
      isActivePickemInPlay = _useSelector.isActivePickemInPlay,
      table = _useSelector.table,
      pickemList = _useSelector.pickemList,
      hasGoalScored = _useSelector.hasGoalScored,
      hasGoalDisallowed = _useSelector.hasGoalDisallowed;

  var hasReadBetbarHelp = app.hasReadBetbarHelp;
  var footballMatch;

  if (activePickem !== null && activePickem !== void 0 && activePickem.id) {
    footballMatch = activePickem === null || activePickem === void 0 ? void 0 : activePickem.sportMatch;
  }

  var hasBet = activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.some(function (obj) {
    return obj === null || obj === void 0 ? void 0 : obj.activeBet;
  });

  var handleGoalUpdateAnimationEnd = function handleGoalUpdateAnimationEnd() {
    console.log("handleGoalUpdateAnimationEnd"); //dispatch(setBetbar({ hasGoalScored: false, hasGoalDisallowed: false }));
  };

  var handleDropdownClicked = function handleDropdownClicked() {
    if ((activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) > 1 && !disableDropdown) {
      dispatch((0, _actions.setBetbar)({
        isBetsOpen: !isBetsOpen
      }));
    }
  };

  var activeBetsCount = activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.filter(function (obj) {
    return obj === null || obj === void 0 ? void 0 : obj.activeBet;
  }).length;
  var prizePool = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.prizeFund) || (activePickem === null || activePickem === void 0 ? void 0 : activePickem.promoPrizeFund);
  var isPromoPrize = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.promoPrizeFund) > 0;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTopRow, {
    disabled: (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) < 2,
    onClick: handleDropdownClicked,
    children: [brandingImageUrl && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledBrandingImage, {
      src: brandingImageUrl
    }), showOnlyFixture && showNavigationArrows && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEnd, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarUpperArrow.default, {
        isLeft: true,
        setBetbarParent: setBetbarParent
      })
    }), !showOnlyFixture && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEnd, {
      children: !(activePickemList !== null && activePickemList !== void 0 && activePickemList.length) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
        skeletonWidth: "100px",
        skeletonHeight: "32px"
      }) : (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) > 1 ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledDropdownButton, {
        needsPulse: !hasReadBetbarHelp && (activePickemList === null || activePickemList === void 0 ? void 0 : activePickemList.length) > 1,
        isBetsOpen: isBetsOpen,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Low6Svg, {}), "Bet Bar", /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.MatIcon, {
          children: "keyboard_arrow_down"
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.IconBlock, {
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.DateTime, {
          format: "dddd",
          children: (_footballMatch = footballMatch) === null || _footballMatch === void 0 ? void 0 : _footballMatch.kickoff
        }),
        icon: "date_range",
        value: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.DateTime, {
          format: ((_footballMatch2 = footballMatch) === null || _footballMatch2 === void 0 ? void 0 : (_footballMatch2$kicko = _footballMatch2.kickoff) === null || _footballMatch2$kicko === void 0 ? void 0 : _footballMatch2$kicko.indexOf(":00:00")) > -1 ? "ha" : "h:mma",
          children: (_footballMatch3 = footballMatch) === null || _footballMatch3 === void 0 ? void 0 : _footballMatch3.kickoff
        })
      })
    }), !(activePickem !== null && activePickem !== void 0 && activePickem.start) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
      skeletonWidth: "126px",
      skeletonHeight: "32px",
      margin: "0 auto"
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_FootballMatch.default, {
      language: app.language,
      hasGoalScored: hasGoalScored,
      hasGoalDisallowed: hasGoalDisallowed,
      onAnimationEnd: handleGoalUpdateAnimationEnd,
      footballMatch: footballMatch,
      isUsingAlternativeImages: isUsingAlternativeImages,
      isLocked: activeBet ? true : false,
      isApproved: isActivePickemApproved,
      isCompleted: isActivePickemCompleted,
      isInPlay: isActivePickemInPlay
    }), showOnlyFixture && showNavigationArrows && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEnd, {
      isRight: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BetbarUpperArrow.default, {
        setBetbarParent: setBetbarParent
      })
    }), !showOnlyFixture && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledEnd, {
      isRight: true,
      children: !(activePickemList !== null && activePickemList !== void 0 && activePickemList.length) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
        skeletonWidth: "100px",
        skeletonHeight: "32px"
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.IconBlock, {
        isSuccess: true,
        label: isPromoPrize ? "Promo Prize" : "Prize Pool",
        icon: "emoji_events",
        value: /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.PenceToPounds, {
          showPoundSign: true,
          children: prizePool
        })
      })
    })]
  });
};

var _default = Wrapper;
exports.default = _default;